import React, { useRef, useEffect, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Card,
  CardContent,
  Box,
  Grid,
  Typography,
  Breadcrumbs,
  Button,
  CircularProgress,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
} from "@material-ui/core";
import * as Yup from "yup";
import AlertMessage from "src/components/ui-components/AlertMessage";
import FormikForm, {
  FormikStep,
} from "src/components/ui-components/FormikForm";
import CustomSkeleton from "src/components/skeleton/Skeleton";
import {
  getPageGroupsAndPages,
  getPageGroupAndPageByKey,
  insertUpdateMenuAndSubMenu,
  getUserGroups,
  getIcons,
} from "./ConnectionService";
import ChevronRightIcon from "src/icons/ChevronRight";
import InputField from "src/components/ui-components/InputField";
import SelectField from "src/components/ui-components/SelectField";
import SwitchField from "src/components/ui-components/SwitchField";
import { AddCircle, ExpandMore, Delete } from "@material-ui/icons";
import SubMenuCreateEdit from "./SubMenuCreateEdit";
import { FieldArray } from "formik";
import MenuFilterCreateEdit from "./MenuFilterCreateEdit";

interface ParamsType {
  pageGroupKey: string;
}

let defaultForm = {
  pageGroupKey: null,
  pageGroupName: "",
  componentTag: "",
  isSystemGroup: false,
  isFooterGroup: false,
  pageGroupAddress: "",
  IconMasterKey: "",
  userGroupKey: "",
  configUserKey: "",
  sortOrder: 1,
  isEnabled: false,
  pages: [],
  pageFilter: [],
};

const defaultPage = {
  pageKey: null,
  pageName: "",
  pageAddress: "",
  IconMasterKey: "",
  sortOrder: 0,
  isEnabled: false,
  pageFilter: [],
};

const defaultPageFilter = {
  pageFilterKey: null,
  pageFilterName: "",
  pageFilterType: "",
  pageFilterWebMethodKey: "",
  pageFilterFieldsSeparater: "",
  isEnabled: false,
  hasConfigurableWidgets: false,
  sortOrder: 1,
  pageFilterValues: [],
};

const MenuGroupCreateEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  // const [pageGroupList, setPageGroupList] = useState<any[]>([]);
  const { pageGroupKey } = (location.state as ParamsType) || {
    pageGroupKey: null,
  };
  const [userGroupsData, setUserGroupsData] = useState([]);
  const [iconsData, setIconsData] = useState([]);
  const email = JSON.parse(localStorage.getItem("userDetails"))?.email;
  const [newSortOrder, setNewSortOrder] = useState(0);
  const userKey = JSON.parse(
    localStorage.getItem("userDetails")
  )?.configUserKey;
  const formRef = useRef(null);
  const resetFormData = (data) => {
    if (formRef && formRef.current) {
      formRef.current.resetForm({
        values: {
          ...data,
          pageGroupKey: data.pageGroups[0].pageGroupKey,
          pageGroupName: data.pageGroups[0].displayName,
          componentTag: data.pageGroups[0].componentTag,
          pageGroupAddress: data.pageGroups[0].route,
          IconMasterKey: data.pageGroups[0].iconMasterKey,
          userGroupKey: data.pageGroups[0].userGroupKey,
          sortOrder: data.pageGroups[0].order,
          isSystemGroup: data.pageGroups[0].isSystemGroup,
          isFooterGroup: data.pageGroups[0].isFooterGroup,
          isEnabled: data.pageGroups[0].isEnabled,
          configUserKey: userKey,
          isEdit: pageGroupKey && true,
          pages: data.pageGroups[0].pages.map((page) => ({
            pageKey: page.menuKey,
            pageName: page.displayName,
            pageAddress: page.route,
            IconMasterKey: page.iconMasterKey,
            sortOrder: page.order,
            isEnabled: page.isEnabled,
            pageFilter: page.pageFilter.map((filter) => ({
              pageFilterKey: filter.pageFilterKey,
              pageFilterName: filter.pageFilterName,
              pageFilterType: filter.pageFilterType,
              pageFilterWebMethodKey: filter.pageFilterWebMethodKey,
              pageFilterFieldsSeparater: filter.pageFilterFieldsSeparater,
              hasConfigurableWidgets: filter.hasConfigurableWidgets,
              sortOrder: 1,
              isEnabled: filter.isEnabled,
              pageFilterValues: filter.pageFilterValues.map((value) => ({
                pageFilterValueKey: value.pageFilterValueKey,
                pageFilterValueName: value.pageFilterValueName,
                pageFilterValue: value.pageFilterValue,
                isDefault: value.isDefault,
                sortOrder: value.sortOrder,
              })),
            })),
          })),
          pageFilter: data.pageGroups[0].pageFilter.map((filter) => ({
            pageFilterKey: filter.pageFilterKey,
            pageFilterName: filter.pageFilterName,
            pageFilterType: filter.pageFilterType,
            pageFilterWebMethodKey: filter.pageFilterWebMethodKey,
            pageFilterFieldsSeparater: filter.pageFilterFieldsSeparater,
            hasConfigurableWidgets: filter.hasConfigurableWidgets,
            sortOrder: 1,
            isEnabled: filter.isEnabled,
            pageFilterValues: filter.pageFilterValues.map((value) => ({
              pageFilterValueKey: value.pageFilterValueKey,
              pageFilterValueName: value.pageFilterValueName,
              pageFilterValue: value.pageFilterValue,
              isDefault: value.isDefault,
              sortOrder: value.sortOrder,
            })),
          })),
        },
      });
    }
  };

  const submitForm = () => {
    if (formRef && formRef.current && !formRef.current.isSubmitting) {
      formRef.current.submitForm();
    }
  };
  const getUserGroupList = (email) => {
    try {
      getUserGroups(email).then((res) => {
        setUserGroupsData(res);
      });
    } catch (err) {
      AlertMessage({ type: "error", msg: err.title });
    }
  };
  const getIconList = () => {
    try {
      getIcons().then((res) => {
        setIconsData(res);
      });
    } catch (err) {
      AlertMessage({ type: "error", msg: err.title });
    }
  };
  const fetchPageGroupList = async () => {
    await getPageGroupsAndPages()
      .then((res) => {
        if (res.pageGroups && res.pageGroups.length > 0) {
          const calculatedNewSortOrder = res.pageGroups.length + 1;
          if (!pageGroupKey) {
            setNewSortOrder(calculatedNewSortOrder);
          }
          defaultForm = {
            ...defaultForm,
            sortOrder: calculatedNewSortOrder,
            configUserKey: userKey,
          };
        } else {
          defaultForm = { ...defaultForm, sortOrder: 1 };
        }
        // setPageGroupList(res);
      })
      .catch((err) => {
        AlertMessage({ type: "error", msg: err.title });
      });
  };
  const fetchPageGroupById = async () => {
    setIsFetching(true);
    await getPageGroupAndPageByKey(pageGroupKey)
      .then((res) => {
        resetFormData(res);
        if (pageGroupKey) {
          setNewSortOrder(res.pageGroups[0].order);
        }
        setIsFetching(false);
      })
      .catch((err) => {
        setIsFetching(false);
        AlertMessage({ type: "error", msg: err.title });
      });
  };
  useEffect(() => {
    getUserGroupList(email);
    getIconList();
    if (pageGroupKey) {
      fetchPageGroupById();
    }
    fetchPageGroupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box sx={{ minHeight: "100vh", pb: 4 }}>
        <Container maxWidth={false}>
          <Grid
            alignItems="center"
            sx={{ my: 2 }}
            container
            justifyContent="space-between"
          >
            <Grid item>
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<ChevronRightIcon fontSize="small" />}
              >
                <Link
                  color="textPrimary"
                  component={RouterLink}
                  to=""
                  variant="h5"
                >
                  Settings
                </Link>
                <Typography color="textSecondary" variant="h5">
                  Menu Groups
                </Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item>
              <Grid alignItems="center" container spacing={2}>
                <Grid item>
                  <Button
                    component={RouterLink}
                    to="/menuGroup"
                    sx={{
                      background:
                        "linear-gradient(to bottom, #939ca3, #939ca3)",
                      minWidth: 100,
                    }}
                    variant="contained"
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    sx={{
                      background:
                        "linear-gradient(to bottom, #09735e, #09735e)",
                      minWidth: 100,
                    }}
                    onClick={submitForm}
                    variant="contained"
                  >
                    Save
                    {isLoading && (
                      <CircularProgress
                        color="inherit"
                        thickness={5}
                        size={20}
                        sx={{ ml: 1 }}
                      />
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Card>
            <CardContent>
              {isFetching && <CustomSkeleton skeletonType="FormEdit" />}
              <Box sx={{ display: isFetching ? "none" : "" }}>
                <FormikForm
                  innerRef={formRef}
                  initialValues={defaultForm}
                  onSubmit={async (values): Promise<void> => {
                    setIsLoading(true);
                    try {
                      await insertUpdateMenuAndSubMenu(values);
                      setIsLoading(false);
                      const msg = values.isEdit
                        ? "Menu details updated successfully"
                        : "Menu details inserted successfully";
                      AlertMessage({ type: "success", msg });
                      navigate("/menugroup");
                    } catch (err) {
                      setIsLoading(false);
                      Object.entries(err.errors).forEach(
                        ([key, errMsg]: any) => {
                          AlertMessage({
                            type: "error",
                            msg: errMsg.errorMessage,
                          });
                        }
                      );
                    }
                  }}
                >
                  <FormikStep
                    validationSchema={Yup.object({
                      pageGroupName: Yup.string()
                        .required("Menu is required")
                        .max(100),
                      pageGroupAddress: Yup.string().nullable().max(100),
                      componentTag: Yup.string().nullable().max(100),
                      IconMasterKey: Yup.string().nullable(),
                      userGroupKey: Yup.string().required(
                        "User Group is required"
                      ),
                      pages: Yup.array().of(
                        Yup.object().shape({
                          pageName: Yup.string()
                            .required("Sub Menu is required")
                            .max(
                              100,
                              "Sub Menu must be at most 100 characters"
                            ),
                          pageAddress: Yup.string()
                            .nullable()
                            .max(
                              100,
                              "Sub menu route must be at most 100 characters"
                            ),
                          IconMasterKey: Yup.string().nullable(),
                          pageFilter: Yup.array().of(
                            Yup.object().shape({
                              pageFilterName: Yup.string()
                                .required("Sub menu filter name is required")
                                .max(
                                  100,
                                  "Sub menu filter name must be at most 100 characters"
                                ),
                              pageFilterType: Yup.string()
                                .nullable()
                                .max(
                                  50,
                                  "Sub menu filter type must be at most 50 characters"
                                ),
                              pageFilterWebMethodKey: Yup.string().required(
                                "Web method is required"
                              ),
                              pageFilterFieldsSeparater: Yup.string()
                                .required(
                                  "Sub menu filter fields separator is required"
                                )
                                .max(
                                  10,
                                  "Sub menu filter fields separator must be at most 10 characters"
                                ),
                            })
                          ),
                          pageFilterValues: Yup.array().of(
                            Yup.object().shape({
                              pageFilterValueName: Yup.string()
                                .required(
                                  "Sub menu filter value name is required"
                                )
                                .max(
                                  100,
                                  "Sub menu filter value name must be at most 100 characters"
                                ),
                              pageFilterValue: Yup.string().required(
                                "Sub menu filter value is required"
                              ),
                            })
                          ),
                        })
                      ),
                      pageFilter: Yup.array().of(
                        Yup.object().shape({
                          pageFilterName: Yup.string()
                            .required("Menu filter name is required")
                            .max(
                              100,
                              "Menu filter name must be at most 100 characters"
                            ),
                          pageFilterType: Yup.string()
                            .required("Menu filter type is required")
                            .max(
                              100,
                              "Menu filter type must be at most 100 characters"
                            ),
                          pageFilterWebMethodKey: Yup.string().required(
                            "Web method is required"
                          ),
                          pageFilterFieldsSeparater: Yup.string()
                            .required(
                              "Sub menu filter fields separator is required"
                            )
                            .max(
                              10,
                              "Sub menu filter fields separator must be at most 10 characters"
                            ),
                          pageFilterValues: Yup.array().of(
                            Yup.object().shape({
                              pageFilterValueName: Yup.string()
                                .required("Menu filter value name is required")
                                .max(
                                  100,
                                  "Menu filter value name must be at most 100 characters"
                                ),
                              pageFilterValue: Yup.string().required(
                                "Menu filter value is required"
                              ),
                            })
                          ),
                        })
                      ),
                    })}
                  >
                    <Grid spacing={5} container>
                      <Grid item xs={6}>
                        <InputField label="Menu" name="pageGroupName" />
                      </Grid>
                      <Grid item xs={6}>
                        <InputField label="Component Tag" name="componentTag" />
                      </Grid>
                      <Grid item xs={6}>
                        <InputField label="Route" name="pageGroupAddress" />
                      </Grid>
                      <Grid item xs={6}>
                        <InputField
                          label="Sort Order"
                          name="sortOrder"
                          value={newSortOrder}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <SelectField
                          name="userGroupKey"
                          label="User Group"
                          data={userGroupsData}
                          dataTextField="userGroup"
                          dataValueField="userGroupKey"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <SelectField
                          name="IconMasterKey"
                          label="Icon"
                          data={iconsData}
                          dataTextField="IconName"
                          dataValueField="IconMasterKey"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <SwitchField
                          name="isSystemGroup"
                          label="Is System Group"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <SwitchField
                          name="isFooterGroup"
                          label="Is Footer Group"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <SwitchField name="isEnabled" label="Is Enabled" />
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <FieldArray name="pages">
                          {({ push, remove }) => (
                            <>
                              <Grid
                                item
                                xs={12}
                                sx={{
                                  textAlign: "right",
                                  paddingRight: 2,
                                  padding: 2,
                                }}
                              >
                                <>
                                  <Button
                                    sx={{
                                      background:
                                        "linear-gradient(to bottom, #09735e, #09735e)",
                                      minWidth: 100,
                                      marginRight: 1,
                                    }}
                                    variant="contained"
                                    type="button"
                                    startIcon={<AddCircle />}
                                    onClick={() => {
                                      const newPage = {
                                        ...defaultPage,
                                        sortOrder:
                                          formRef.current.values.pages.length +
                                          1,
                                      };
                                      push(newPage);
                                      formRef.current.setFieldValue("pages", [
                                        ...formRef.current.values.pages,
                                        newPage,
                                      ]);
                                    }}
                                    disabled={
                                      formRef?.current?.values?.pageFilter
                                        ?.length > 0
                                    }
                                  >
                                    Add Sub Menu
                                  </Button>
                                  <Button
                                    sx={{
                                      background:
                                        "linear-gradient(to bottom, #09735e, #09735e)",
                                      minWidth: 100,
                                      marginRight: 1,
                                    }}
                                    variant="contained"
                                    type="button"
                                    startIcon={<AddCircle />}
                                    onClick={() => {
                                      const newPageFilter = {
                                        ...defaultPageFilter,
                                        sortOrder: 1,
                                      };
                                      formRef?.current?.setFieldValue(
                                        "pageFilter",
                                        [
                                          ...formRef?.current?.values
                                            ?.pageFilter,
                                          newPageFilter,
                                        ]
                                      );
                                    }}
                                    disabled={
                                      formRef?.current?.values?.pages?.length >
                                      0
                                    }
                                  >
                                    Add Menu Filter
                                  </Button>

                                  <Button
                                    sx={{
                                      background:
                                        "linear-gradient(to bottom, #09735e, #09735e)",
                                      minWidth: 100,
                                      marginRight: 1,
                                    }}
                                    variant="contained"
                                    type="button"
                                    startIcon={<AddCircle />}
                                    disabled={
                                      formRef?.current?.values?.pages?.length >
                                        0 ||
                                      formRef?.current?.values?.pageFilter
                                        ?.length > 0
                                    }
                                  >
                                    Add Widget
                                  </Button>
                                </>
                              </Grid>
                              {formRef?.current?.values?.pages?.map(
                                (page, index) => (
                                  <Accordion key={index} defaultExpanded>
                                    <AccordionSummary
                                      expandIcon={<ExpandMore />}
                                    >
                                      <Typography
                                        variant="h6"
                                        gutterBottom
                                        sx={{ marginBottom: -4 }}
                                      >
                                        Sub Menu {index + 1}
                                        <IconButton
                                          type="button"
                                          onClick={() => remove(index)}
                                        >
                                          <Delete style={{ fontSize: 20 }} />
                                        </IconButton>
                                      </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <SubMenuCreateEdit
                                        pages={formRef.current.values.pages}
                                        index={index}
                                      />
                                    </AccordionDetails>
                                  </Accordion>
                                )
                              )}
                            </>
                          )}
                        </FieldArray>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        {<MenuFilterCreateEdit formRef={formRef} />}
                      </Grid>
                    </Grid>
                  </FormikStep>
                </FormikForm>
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default MenuGroupCreateEdit;
